import { pipeActions } from './actionHandler/utils';

export function emitCustomEvent(instance, trigger, global, meta, payload) {
  const actions = instance.actions.filter(i => i.trigger === trigger);
  if (!actions.length) {
    return;
  }
  const handler = pipeActions(actions, instance, null, payload);
  return handler(undefined, { global, meta });
}
